<template>
	<div class="home">
		<MauritiusFuelPrices />
	</div>
</template>

<script>
import MauritiusFuelPrices from "../components/mauritius-fuel-prices";
export default {
	name: "home",
	components: { MauritiusFuelPrices }
};
</script>
